// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-filters{
    width: 100%;
    margin-top: 1em;
    position: relative;
    padding: 0 0.6em;
    background-color: inherit;
}

.box-filters label{
    font-weight: bold;
    margin-bottom: 0.5em;
    font-size: 0.6em;
}

.box-filters .container-select{
    position: relative;
    display: flex;
    width: auto;
    height: 1.2em;
    line-height: 1.2em;
    overflow: hidden;
    border-radius: .25em;
    background-color: var(--low-light);
    border: 1px solid rgb(216, 220, 222); 
}

.box-filters .container-select::after{
    content: '\\25BC';
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 0.7em;
    cursor: pointer;
    pointer-events: none;
    transition: .25s all ease;
    font-size: 0.55em;
    background: var(--primary-purple-sensedia);
    color: var(--white);
}

.box-filters .container-select:hover{
    transition: 0.2s;
    border: 1px solid rgb(78, 78, 155);
}

.box-filters .container-select:hover::after{
    color: var(--low-light);
}

.box-filters select{
    appearance: none;
    border: 0!important;
    flex: 1 1;
    cursor: pointer;
    padding-left: 1em;
    font-size: 0.6em;
    background: var(--white);
    color: var(--black);
}

.box-filters select::-ms-expand{
    display: none;
}

`, "",{"version":3,"sources":["webpack://./src/components/filterSeverity/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;IACjB,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAO;IACP,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".box-filters{\n    width: 100%;\n    margin-top: 1em;\n    position: relative;\n    padding: 0 0.6em;\n    background-color: inherit;\n}\n\n.box-filters label{\n    font-weight: bold;\n    margin-bottom: 0.5em;\n    font-size: 0.6em;\n}\n\n.box-filters .container-select{\n    position: relative;\n    display: flex;\n    width: auto;\n    height: 1.2em;\n    line-height: 1.2em;\n    overflow: hidden;\n    border-radius: .25em;\n    background-color: var(--low-light);\n    border: 1px solid rgb(216, 220, 222); \n}\n\n.box-filters .container-select::after{\n    content: '\\25BC';\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0 0.7em;\n    cursor: pointer;\n    pointer-events: none;\n    transition: .25s all ease;\n    font-size: 0.55em;\n    background: var(--primary-purple-sensedia);\n    color: var(--white);\n}\n\n.box-filters .container-select:hover{\n    transition: 0.2s;\n    border: 1px solid rgb(78, 78, 155);\n}\n\n.box-filters .container-select:hover::after{\n    color: var(--low-light);\n}\n\n.box-filters select{\n    appearance: none;\n    border: 0!important;\n    flex: 1;\n    cursor: pointer;\n    padding-left: 1em;\n    font-size: 0.6em;\n    background: var(--white);\n    color: var(--black);\n}\n\n.box-filters select::-ms-expand{\n    display: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
